import React, { FC, createContext } from "react";
import { ISpfxComponentUser } from "@excentone/spfx-core-lib";
import {
  GetUserIdentityType,
  IUserIdentityContextProps,
  UserIdentityContext,
} from "./UserIdentityContext.types";

export const createUserIdentityContext = <TUser extends ISpfxComponentUser>(
  initialValues?: IUserIdentityContextProps<TUser>
): UserIdentityContext<TUser> =>
  createContext<IUserIdentityContextProps<TUser>>(initialValues);

export const createUserIdentityContextProvider = <
  TContext extends UserIdentityContext<ISpfxComponentUser>
>(
  context: TContext
): FC<IUserIdentityContextProps<GetUserIdentityType<TContext>>> => {
  const UserIdentityContextProvider: FC<
    IUserIdentityContextProps<GetUserIdentityType<TContext>>
  > = ({ children, ...value }) => (
    <context.Provider value={value}>{children}</context.Provider>
  );
  return UserIdentityContextProvider;
};
